import React from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

const useStyles = makeStyles({
  root: {
    overflow: 'unset',
  },
});

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.background.default,
    },
  },
}))(TableRow);

export default function AcccessibleTable(props) {
  const classes = useStyles();

  return (
    <TableContainer
      component={Paper}
      classes={{
        root: classes.root,
      }}
    >
      <Table className={classes.table} size="small">
        <TableHead>
          <StyledTableRow>
            {props.thArray.map((th, i) => (
              <StyledTableCell key={i}>{th}</StyledTableCell>
            ))}
          </StyledTableRow>
        </TableHead>
        <TableBody>
          {props.tdArray.map((row, i) => (
            <StyledTableRow key={i}>
              {row.map((td, index) => (
                <StyledTableCell component="th" scope="row" key={index}>
                  {td}
                </StyledTableCell>
              ))}
            </StyledTableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
